import React from 'react';
import { Link } from 'react-router-dom';

const TrustReliabilityCompliance = () => {
  const features = [
    {
      id: 1,
      title: 'End-to-End Data Encryption',
      description: 'Protects data across devices, networks, and platforms.',
      image: '/assets/AMI/4section-1.svg'
    },
    {
      id: 2,
      title: 'Secure Device Authentication',
      description: 'Ensures only authorized devices and users can access the system.',
      image: '/assets/AMI/4section-2.svg'
    },
    {
      id: 3,
      title: 'Data Integrity',
      description: 'Safeguards meter data against unauthorized modification or interference.',
      image: '/assets/AMI/4section-3.svg'
    },
    {
      id: 4,
      title: 'Regulatory Compliance',
      description: 'Meets applicable standards and regulatory requirements for secure metering.',
      image: '/assets/AMI/4section-4.svg'
    }
  ];

  return (
    <section className="bg-white relative">
      {/* Top Section - Header */}
      <div className="py-8 md:py-12 lg:py-16">
        <div className="container mx-auto px-4 md:px-8 max-w-6xl">
          {/* Header */}
          <div className="text-center mb-2 md:mb-4">
            <h2 className="font-bold mb-4 md:mb-5">
              <span className="">Built for Trust, Reliability, and </span>
              <span className="secondary-text">Regulatory Compliance</span>
            </h2>
            <p className="   max-w-3xl mx-auto px-4">
              Security is embedded at every layer of Avexa's AMI architecture to protect critical infrastructure and 
              sensitive data.
            </p>
          </div>
        </div>
      </div>

      {/* Blue Section with Cards overlapping top */}
      {/* <div className="primary-bg pt-16 md:pt-20 pb-12 md:pb-16 lg:pb-20 -mt-12 md:-mt-16"> */}
        <div className="container mx-auto px-4 md:px-8 max-w-7xl relative">
          {/* Features Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-5 lg:gap-6">
            {features.map((feature, index) => (
              <div
                key={feature.id}
                className="group relative rounded-xl overflow-hidden shadow-md cursor-pointer transition-all duration-300 h-42 md:h-46"
              >
                {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
                {/* Dark Overlay */}
                <div className="absolute inset-0 primary-bg opacity-80"></div>
              </div>

              {/* Content */}
              <div className="relative z-10 flex flex-col items-center justify-center h-full p-5 md:p-6">
                <h3 className="text-white   font-bold mb-3 text-center leading-snug">
                  {feature.title}
                </h3>
                <p className="text-white text-xs md: leading-relaxed text-center opacity-90">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

          {/* CTA Section */}
          {/* <div className="primary-bg pt-28 md:pt-32 pb-12 md:pb-16 lg:pb-20 -mt-12 md:-mt-16">
        <div className="container mx-auto px-4 md:px-8 max-w-6xl">
          <div className="text-center pt-8 md:pt-12">
            <h2 className="font-bold text-white mb-4 md:mb-5">
              <span className="text-white">Transform Your Metering </span>
              <span className="secondary-text">Infrastructure with Avexa</span>
            </h2>
            
            <p className="  text-white opacity-90 max-w-3xl mx-auto mb-6 md:mb-8">
              Modernize your metering ecosystem with a secure, intelligent, and scalable AMI solution 
              designed for today's digital enterprises.
            </p>

            <Link to="/get-in-touch" className="btn-secondary   font-semibold px-8 md:px-10 py-3 md:py-3.5">
              Contact Us
            </Link>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default TrustReliabilityCompliance;

// import React from 'react';

// const TrustReliabilityCompliance = () => {
//   const features = [
//     {
//       id: 1,
//       title: 'End-to-End Data Encryption',
//       description: 'Protects data across devices, networks, and platforms.',
//       image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=600&fit=crop'
//     },
//     {
//       id: 2,
//       title: 'Secure Device Authentication',
//       description: 'Ensures only authorized devices and users can access the system.',
//       image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=600&fit=crop'
//     },
//     {
//       id: 3,
//       title: 'Data Integrity',
//       description: 'Safeguards meter data against unauthorized modification or interference.',
//       image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop'
//     },
//     {
//       id: 4,
//       title: 'Regulatory Compliance',
//       description: 'Meets applicable standards and regulatory requirements for secure metering.',
//       image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
//     }
//   ];

//   return (
//     <section className="bg-white relative">
//       {/* Top Section - Header */}
//       <div className="py-12 md:py-16 lg:py-20">
//         <div className="container mx-auto px-4 md:px-8 max-w-6xl">
//           {/* Header */}
//           <div className="text-center mb-10 md:mb-12">
//             <h2 className="font-bold mb-4 md:mb-5">
//               <span style={{ color: '#003366' }}>Built for Trust, Reliability, and </span>
//               <span style={{ color: '#FF6B35' }}>Regulatory Compliance</span>
//             </h2>
//             <p className="  text-gray-700 max-w-3xl mx-auto px-4">
//               Security is embedded at every layer of Avexa's AMI architecture to protect critical infrastructure and 
//               sensitive data.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Cards Section - Positioned to overlap both white and blue sections */}
//       <div className="container mx-auto px-4 md:px-8 max-w-6xl relative z-10">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-6 lg:gap-7">
//           {features.map((feature, index) => (
//             <div
//               key={feature.id}
//               className="group relative rounded-2xl overflow-hidden shadow-2xl cursor-pointer transition-all duration-300 h-48 md:h-52"
//               style={{
//                 border: '3px solid transparent',
//                 transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.borderColor = '#00D4FF';
//                 e.currentTarget.style.boxShadow = '0 0 30px rgba(0, 212, 255, 0.6)';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.borderColor = 'transparent';
//                 e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
//               }}
//             >
//               {/* Background Image */}
//               <div className="absolute inset-0">
//                 <img
//                   src={feature.image}
//                   alt={feature.title}
//                   className="w-full h-full object-cover"
//                 />
//                 {/* Dark Overlay with tech pattern */}
//                 <div 
//                   className="absolute inset-0" 
//                   style={{ 
//                     backgroundColor: 'rgba(0, 20, 60, 0.85)',
//                     backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(0, 100, 200, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(0, 150, 255, 0.1) 0%, transparent 50%)'
//                   }}
//                 ></div>
//               </div>

//               {/* Content */}
//               <div className="relative z-10 flex flex-col items-center justify-center h-full p-5 md:p-6">
//                 <h3 className="text-white   font-bold mb-3 text-center leading-snug">
//                   {feature.title}
//                 </h3>
//                 <p className="text-white text-xs md: leading-relaxed text-center opacity-90">
//                   {feature.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Blue Section - Starts from middle of cards */}
//       <div style={{ backgroundColor: '#003366' }} className="pt-32 md:pt-36 pb-12 md:pb-16 lg:pb-20 -mt-24 md:-mt-28">
//         <div className="container mx-auto px-4 md:px-8 max-w-6xl">
//           {/* CTA Section */}
//           <div className="text-center pt-8 md:pt-12">
//             <h2 className="font-bold text-white mb-4 md:mb-5">
//               <span className="text-white">Transform Your Metering </span>
//               <span style={{ color: '#FF6B35' }}>Infrastructure with Avexa</span>
//             </h2>
            
//             <p className="  text-white opacity-90 max-w-3xl mx-auto mb-6 md:mb-8">
//               Modernize your metering ecosystem with a secure, intelligent, and scalable AMI solution 
//               designed for today's digital enterprises.
//             </p>

//             <button 
//               className="  font-semibold px-8 md:px-10 py-3 md:py-3.5 rounded-lg transition-all duration-300 hover:scale-105"
//               style={{ backgroundColor: '#FF6B35', color: 'white' }}
//             >
//               Contact Us
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TrustReliabilityCompliance;

// import React from 'react';

// import cardImage1 from '../../assets/AMI/4section-1.svg';
// import cardImage2 from '../../assets/AMI/4section-2.svg';
// import cardImage3 from '../../assets/AMI/4section-3.svg';
// import cardImage4 from '../../assets/AMI/4section-4.svg';

// const TrustReliabilityCompliance = () => {
//   const features = [
//     {
//       id: 1,
//       title: 'End-to-End Data Encryption',
//       description: 'Protects data across devices, networks, and platforms.',
//       image: cardImage1
//     },
//     {
//       id: 2,
//       title: 'Secure Device Authentication',
//       description: 'Ensures only authorized devices and users can access the system.',
//       image: cardImage2
//     },
//     {
//       id: 3,
//       title: 'Data Integrity',
//       description: 'Safeguards meter data against unauthorized modification or interference.',
//       image: cardImage3
//     },
//     {
//       id: 4,
//       title: 'Regulatory Compliance',
//       description: 'Meets applicable standards and regulatory requirements for secure metering.',
//       image: cardImage4
//     }
//   ];

//   return (
//     <section className="bg-white relative">
//       {/* Top Section - Header */}
//       <div className="py-12 md:py-16 lg:py-20">
//         <div className="container mx-auto px-4 md:px-8 max-w-6xl">
//           {/* Header */}
//           <div className="text-center mb-10 md:mb-12">
//             <h2 className="font-bold mb-4 md:mb-5">
//               <span style={{ color: '#003366' }}>Built for Trust, Reliability, and </span>
//               <span style={{ color: '#FF6B35' }}>Regulatory Compliance</span>
//             </h2>
//             <p className="  text-gray-700 max-w-3xl mx-auto px-4">
//               Security is embedded at every layer of Avexa's AMI architecture to protect critical infrastructure and 
//               sensitive data.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Cards Section - Positioned to overlap both white and blue sections */}
//       <div className="container mx-auto px-4 md:px-8 max-w-6xl relative z-10">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-6 lg:gap-7">
//           {features.map((feature, index) => (
//             <div
//               key={feature.id}
//               className="group relative rounded-2xl overflow-hidden shadow-2xl cursor-pointer transition-all duration-300 h-48 md:h-52"
//             >
//               {/* Background Image */}
//               <div className="absolute inset-0">
//                 <img
//                   src={feature.image}
//                   alt={feature.title}
//                   className="w-full h-full object-cover"
//                 />
//                 {/* Dark Overlay with tech pattern */}
//                 <div 
//                   className="absolute inset-0" 
//                   style={{ 
//                     backgroundColor: 'rgba(0, 20, 60, 0.85)',
//                     backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(0, 100, 200, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(0, 150, 255, 0.1) 0%, transparent 50%)'
//                   }}
//                 ></div>
//               </div>

//               {/* Content */}
//               <div className="relative z-10 flex flex-col items-center justify-center h-full p-5 md:p-6">
//                 <h3 className="text-white   font-bold mb-3 text-center leading-snug">
//                   {feature.title}
//                 </h3>
//                 <p className="text-white text-xs md: leading-relaxed text-center opacity-90">
//                   {feature.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Blue Section - Starts from middle of cards */}
//       <div style={{ backgroundColor: '#003366' }} className="pt-32 md:pt-36 pb-12 md:pb-16 lg:pb-20 -mt-24 md:-mt-28">
//         <div className="container mx-auto px-4 md:px-8 max-w-6xl">
//           {/* CTA Section */}
//           <div className="text-center pt-8 md:pt-12">
//             <h2 className="font-bold text-white mb-4 md:mb-5">
//               <span className="text-white">Transform Your Metering </span>
//               <span style={{ color: '#FF6B35' }}>Infrastructure with Avexa</span>
//             </h2>
            
//             <p className="  text-white opacity-90 max-w-3xl mx-auto mb-6 md:mb-8">
//               Modernize your metering ecosystem with a secure, intelligent, and scalable AMI solution 
//               designed for today's digital enterprises.
//             </p>

//             <button 
//               className="  font-semibold px-8 md:px-10 py-3 md:py-3.5 rounded-lg transition-all duration-300 hover:scale-105"
//               style={{ backgroundColor: '#FF6B35', color: 'white' }}
//             >
//               Contact Us
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TrustReliabilityCompliance;